<template>
    <div 
        id="app"
        class="p-8 w-full">
        
        <div v-if="!auth.token">
            <form @submit.prevent="login()">
                Brukernavn:<br>
                <input type="text" v-model="auth.username">
                
                Passord:<br>
                <input type="password" v-model="auth.password">
                
                <button class="button submit">Logg inn</button>
            </form>
        </div>
        <div v-else>
            <div v-if="form">
                <div class="no-print mb-8">
                    <button 
                        class="button submit mr-4"
                        @click="openPrint()">
                        Print
                    </button>
                    <button 
                        class="button "
                        @click="formDelete(form)">
                        Slett
                    </button>
                    <a 
                        @click="form = null"
                        class="block float-right">
                        Lukk søknad
                    </a>
                </div>
                
                <div 
                    v-if="form.urls"
                    class="no-print">
                    Vedlegg<br>
                    
                    <div v-if="!form.urls.length">
                        Søknaden har ingen vedlegg.
                    </div>
                    <div v-else>
                        <a 
                            v-for="presignedUrl in form.urls"
                            :key="presignedUrl.Key"
                            class=" mr-2 mt-2 clear-both float-left"
                            :href="presignedUrl.url"
                            target="_blank">
                            Last ned vedlegg ( {{presignedUrl.Key | formatKeyExtension }} )
                        </a>
                    </div>
                </div>
                <div v-else>
                    Laster vedlegg...
                </div>
                
                
                <div 
                    v-for="(section, sI) in form.content.sections"
                    :key="sI"
                    class="mt-8">
                    
                    <h2 
                        v-if="
                            section.title && 
                            section.fields
                        " 
                        class="text-lg font-bold  mb-4"
                        style="page-break-before: always;">
                        
                        {{section.title}}
                    </h2>
                    
                    <table>
                        <tr 
                            v-for="(field, fI) in section.fields"
                            :key="fI">
                            
                            <th style="width: 300px;">{{field.name}}</th>
                            <td>
                                <div 
                                    v-if="
                                        field.type == 'singleline' ||
                                        field.type == 'multiline' ||
                                        field.type == 'radio'
                                    ">
                                    <p v-if="field.content.length || field.content!=''">
                                        {{field.content}}
                                    </p>
                                </div>
                                <div v-else-if="field.type == 'checkbox'">
                                    <ul class="ml-6">
                                        <li 
                                            v-for="item in field.content" 
                                            :key="item"
                                            class="list-disc">
                                            {{item}}
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div v-else>
                <div v-if="!forms">
                    Laster søknader
                </div>
                <div v-else>
                    <h1 class="text-2xl">Søknader {{forms.length}}</h1>
                    <a @click="formList()">Oppdater listen</a>
                    
                    <table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Innhold</th>
                                <th>Dato</th>
                                <th>Last ned</th>
                                <th>Slett</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr 
                                v-for="(form, index) in forms"
                                :key="index">
                                
                                <td>{{form.id}}</td>
                                <td>
                                    <span v-if="form.file">
                                        Innsendt
                                    </span>
                                    <span v-else>
                                        Har vedlegg. Ikke Innsendt.
                                    </span>
                                </td>
                                <td>
                                    <span v-if="form.created">
                                        {{form.created | formateDate}}
                                    </span>
                                </td>
                                <td>
                                    <a 
                                        v-if="form.file"
                                        @click="showForm(form)">
                                        Åpne søknad
                                    </a>
                                </td>
                                <td>
                                    <a @click="formDelete(form)">Slett</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import MiscMixins from '@/mixins/MiscMixins';
    
    export default {
        // mixins: [
        //     MiscMixins
        // ],
        
        filters: {
            formateDate(value) {
                return new Date( value ).toLocaleString('nb');
            },
            formatKeyExtension(value) {
                const filename = value.split('/').reverse()[0];
                return filename.split('.').reverse()[0];
            }
        },
        
        data() {
            return {
                auth: {
                    username: null,
                    password: null,
                    token: null,
                },
                forms: null,
                form: null,
            }
        },
        
        methods: {
            async login(){
                try {
                    const response = await this.$axios.post( process.env.VUE_APP_API_ENDPOINT + '/auth', {auth: this.auth} );
                    if ( response.data.token ) {
                        this.auth.token = response.data.token;
                        this.formList();
                        // console.log('response valid!', response.data);
                    }
                } 
                catch (error) {
                    alert('Noe galt skjedde ved innlogging.');
                    console.error(error);
                }
            },
            
            async formList() {
                try {
                    this.forms = null;
                    const response = await this.$axios.get( process.env.VUE_APP_API_ENDPOINT + '/form?token='+this.auth.token );
                    
                    if (response.data && response.data.forms) {
                        this.forms = response.data.forms
                            .sort( (a, b) => new Date(a.created) - new Date(b.created) )
                            .reverse();
                    }
                } 
                catch (error) {
                    alert('Noe galt skjedde ved lasting av søknader.');
                    console.error(error);
                }
            },
            
            async showForm(form){
                form.urls = await this.formGetAttachments( form );
                this.form = form;
            },
            
            async formGetAttachments( form ) {
                try {
                    const response = await this.$axios.post( process.env.VUE_APP_API_ENDPOINT + '/form/'+ form.id, {
                        auth: this.auth,
                        attachments: form.attachments,
                    });
                    
                    // console.log('formGet', response.data);
                    return response.data.urls;
                } 
                catch (error) {
                    alert('Noe galt skjedde ved lasting av vedlegg.');
                    console.error(error);
                }
            },
            
            async formDelete( form ) {
                try {
                    if (! confirm('Er du sikker?')) return; 
                    
                    const response = await this.$axios.delete( process.env.VUE_APP_API_ENDPOINT + '/form/'+ form.id, { data: {auth: this.auth} } );
                    // console.log('formDelete', response.data);
                    this.forms = this.forms.filter( f => f != form);
                    
                    this.form = null;
                } 
                catch (error) {
                    alert('Noe galt skjedde ved sletting.');
                    console.error(error);
                }
            },
            
            openPrint(){
                window.print();
            },
        },
    }
</script>

<style lang="scss" scoped>
    a {
        @apply text-blue-600;
        @apply cursor-pointer;
        
        &:hover {
            @apply text-blue-900;
        }
    }
</style>
